import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#0a0a0a] text-gray-300 text-sm py-2 px-6 flex flex-col items-start space-y-1 z-20 relative" data-id="element-30">
      <div className="flex items-center space-x-2" data-id="element-31">
        <Phone size={14} className="text-gray-400" data-id="element-32" />
        <span data-id="element-33">(888) 267-1870</span>
      </div>
      <div className="flex items-center space-x-2" data-id="element-34">
        <Mail size={14} className="text-gray-400" data-id="element-35" />
        <a href="mailto:admin@lspm.com" className="text-[#5a9e3f] hover:underline transition-colors" data-id="element-36">
          admin@lspm.com
        </a>
      </div>
    </div>;
}